import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { OfferCardData, OfferCardSubtype, OfferCardType, OfferViewType } from "../offer-card-data.model";
import { Currency } from "../../../model/landingModel";
import { LoyaltyMode } from "@shopping-angular-components/loyalty";
import { UserFavoriteCardData } from '../../user-favorites/user-favorite-data.model';
import { UpaTarget } from 'projects/common/services/upa.service';

@Component({
  selector: 'offer-card-selector',
  template: `
    <ng-container [ngSwitch]="offerCardType">
      <ranking-number *ngIf="rankedItems" [position]="positionIndex + 1" [variant]="offerCardType === 'SIMPLIFIED' ? 'full-rounded' : 'default'"></ranking-number>

      <detailed-offer-card *ngSwitchCase="'DETAILED'"
                        [moduleId]="moduleId" [moduleIndex]="moduleIndex" [uniqueId]="uniqueId"
                        [positionIndex]="positionIndex" [highlighted]="highlighted"
                        [data]="data" [currency]="currency" [locale]="locale" [loyaltyMode]=" loyaltyMode"
                        [flow]="flow" [product]="product" [moduleReferer]="moduleReferer"></detailed-offer-card>

      <reduced-offer-card *ngSwitchCase="'REDUCED'"
                        [moduleId]="moduleId" [moduleIndex]="moduleIndex" [uniqueId]="uniqueId"
                        [positionIndex]="positionIndex" [highlighted]="highlighted"
                        [data]="data" [currency]="currency" [locale]="locale" [loyaltyMode]=" loyaltyMode"
                        [flow]="flow" [product]="product" [moduleReferer]="moduleReferer"></reduced-offer-card>

      <just-dates-offer-card *ngSwitchCase="'MINI'"
                        [moduleId]="moduleId" [moduleIndex]="moduleIndex" [uniqueId]="uniqueId"
                        [positionIndex]="positionIndex"
                        [data]="data" [currency]="currency" [locale]="locale" [loyaltyMode]=" loyaltyMode"
                        [flow]="flow" [product]="product" [moduleReferer]="moduleReferer"></just-dates-offer-card>

      <simplified-offer-card *ngSwitchCase="'SIMPLIFIED'"
                        [moduleId]="moduleId" [moduleIndex]="moduleIndex" [uniqueId]="uniqueId"
                        [positionIndex]="positionIndex" [cardDisplay]="offerCardSubtype"
                        [data]="data" [currency]="currency" [locale]="locale" [loyaltyMode]=" loyaltyMode"
                        [flow]="flow" [product]="product" [moduleReferer]="moduleReferer"></simplified-offer-card>

      <wow-offer-card *ngSwitchCase="'WOW'"
                        [moduleId]="moduleId" [moduleIndex]="moduleIndex" [uniqueId]="uniqueId"
                        [positionIndex]="positionIndex"
                        [data]="data" [currency]="currency" [locale]="locale" [loyaltyMode]=" loyaltyMode"
                        [flow]="flow" [product]="product" [moduleReferer]="moduleReferer"></wow-offer-card>

      <user-favorite-card *ngSwitchCase="'SUMMARY'"
                        [data]="getFavoriteCardData()"
                        [locale]="locale"
                        [flow]="flow"
                        [currency]="currency"
                        [showDeleteBtn]="false"
                        [showAlertBtn]="false"
                        [moduleId]="moduleId"
                        [moduleIndex]="moduleIndex"
                        [uniqueId]="uniqueId"
                        [target]="target"/>
      <list-offer-card *ngSwitchCase="'LIST'"
        [data]="data"
        [currency]="currency"
        [isLast]="isLast"
        [moduleId]="moduleId"
        [moduleIndex]="moduleIndex"
        [positionIndex]="positionIndex"
        [uniqueId]="uniqueId"
        [moduleReferer]="moduleReferer"
        [sboxAutocomplete]="sboxAutocomplete"
      >
      </list-offer-card>
      <ng-container *ngSwitchCase="'BASIC'">
        <user-favorite-card *ngIf="data.product === 'FLIGHT'; else basicOfferCard"
          [data]="getFavoriteCardData()"
          [locale]="locale"
          [flow]="flow"
          [currency]="currency"
          [showDeleteBtn]="false"
          [showAlertBtn]="false"
          [moduleId]="moduleId"
          [moduleIndex]="moduleIndex"
          [uniqueId]="uniqueId"
          [target]="target"
        />
        <ng-template #basicOfferCard>
          <basic-offer-card 
            [moduleId]="moduleId" 
            [moduleIndex]="moduleIndex" 
            [uniqueId]="uniqueId"
            [positionIndex]="positionIndex"
            [data]="data" 
            [currency]="currency" 
            [locale]="locale" 
            [loyaltyMode]=" loyaltyMode"
            [flow]="flow" 
            [product]="product"
            [moduleReferer]="moduleReferer"
          ></basic-offer-card>
        </ng-template>
      </ng-container>

      <common-offer-card *ngSwitchDefault
                         [moduleId]="moduleId" [moduleIndex]="moduleIndex" [uniqueId]="uniqueId"
                         [positionIndex]="positionIndex" [highlighted]="highlighted" [isFixedWidth]="isFixedWidth"
                         [data]="data" [currency]="currency" [locale]="locale" [loyaltyMode]=" loyaltyMode"
                         [flow]="flow" [product]="product" [sboxAutocomplete]="sboxAutocomplete" [moduleReferer]="moduleReferer" (offerClicked)="onOfferClicked()"></common-offer-card>
    </ng-container>
  `,
  styleUrls: ['./offer-card-selector.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class OfferCardSelectorComponent implements OnInit {
  @Input() moduleId: string;
  @Input() moduleIndex: number;
  @Input() uniqueId: string;
  @Input() positionIndex: number;
  @Input() offerViewType: OfferViewType;
  @Input() offerCardType: OfferCardType;
  @Input() offerCardSubtype: OfferCardSubtype | undefined;
  @Input() detailOffer = false;

  @Input() data: OfferCardData;
  @Input() currency: Currency;
  @Input() locale: string;
  @Input() loyaltyMode: LoyaltyMode | null;
  @Input() flow: string;
  @Input() product: string;
  @Input() sboxAutocomplete?: boolean;
  @Input() rankedItems: boolean;
  @Input() isFixedWidth: boolean;
  @Input() isLast: boolean;
  @Input() moduleReferer?: string;

  @Output() offerClicked = new EventEmitter<void>();

  highlighted: boolean = false;
  target: UpaTarget = UpaTarget.OFFER;

  ngOnInit(): void {
    this.product = this.product || this.data.product;
    this.highlighted = this.offerViewType && this.offerViewType === OfferViewType.HIGHLIGHTED;

    // TODO: Transforma tickets de BASIC a COMMON hasta tener definido el diseño de BASIC
    if (this.data.product === 'tickets' && this.offerCardType === OfferCardType.BASIC) {
      this.offerCardType = OfferCardType.COMMON;
    }
  }

  getFavoriteCardData(): UserFavoriteCardData {
    return this.data as UserFavoriteCardData;
  }

  onOfferClicked(): void {
    this.offerClicked.emit();
  }
}
